import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryParams } from '@/@diffrag/hooks/useQueryParams'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { useToast } from '@/components/ui/use-toast'
import {
  ArticleTypeEnum1,
  IAdminCommentRO,
  IAdminCommentUpdateStatusStatusEnum,
} from 'api'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

export default function CommentDetail() {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const id = searchParams.get('id')
  const articleId = searchParams.get('articleId')

  const { toast } = useToast()
  const { query } = useQueryParams<{
    articleType: ArticleTypeEnum1
  }>({
    articleType: ArticleTypeEnum1.ClinicEquipment,
  })

  const { data, refetch } = useApi({
    id: 'commentDetail',
    fn: api().adminComment.getCommentDetail,
    params: {
      articleType: query.articleType,
      id: Number(id),
      articleId: Number(articleId),
      page: 1,
      pageSize: 10,
    },
  })

  const onDelete = async () => {
    try {
      await api().adminComment.adminCommentDelete(Number(id), {
        type: query.articleType as never,
      })

      navigate('/comment')
    } catch (error) {
      console.error('삭제 중 오류 발생:', error)
      toast({
        variant: 'destructive',
        title: '삭제 중 오류가 발생했습니다.',
      })
    }
  }

  const onSave = async (data: any) => {
    if (id) {
      await api().adminComment.adminCommentPartialUpdate(Number(id), {
        status: data.active
          ? IAdminCommentUpdateStatusStatusEnum.ACTIVE
          : IAdminCommentUpdateStatusStatusEnum.INACTIVE,
        type: query.articleType as never,
      })
    }

    navigate('/comment')
  }

  return (
    <ContentDetailView
      title="댓글 상세"
      data={data}
      onSave={onSave}
      onDelete={onDelete}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: 'ID',
            key: 'id',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '작성자',
            key: data?.author.clinic?.name
              ? 'author.clinic.name'
              : 'author.userData.nickname',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '게시글 제목',
            key: 'article.title',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            label: '댓글 내용',
            key: 'content',
            type: FormFieldType.TEXT,
            readOnly: true,
          },
          {
            label: '작성일시',
            key: 'createDate',
            type: FormFieldType.DATE,
            readOnly: true,
            timePicker: true,
          },
          {
            label: '수정일시',
            key: 'updateDate',
            type: FormFieldType.DATE,
            timePicker: true,
            readOnly: true,
          },
          {
            label: '활성화',
            key: 'active',
            type: FormFieldType.CHECKBOX,

            required: true,
          },
        ]}
      />
    </ContentDetailView>
  )
}
